module.exports = __webpack_public_path__ + "img/menu-app.53c60b9e.svg";